import { FormSectionHandler } from '../entity.handler';
import { UserRoleResponse, UserRoleUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    description?: string;
}

export class UserRoleDetailsSectionHandler implements FormSectionHandler<UserRoleResponse, EditorValues> {

    type = 'form';
    icon = ICONS.userrole;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private properties = ['name', 'description'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.USERROLE.DETAILS.${key}`, values);
    }

    applyUpdate(entity: UserRoleResponse, payload: UserRoleUpdateRequest): Promise<UserRoleResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateUserRole(entity.id, payload));
    }

    mapEntityToEditor(entity: UserRoleResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: UserRoleUpdateRequest, values: EditorValues): Promise<UserRoleUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: UserRoleResponse): Promise<FormBuilderField[]> {
        return Promise.resolve().then(() => {
            return [
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
                TextField('description', this.translate('FIELDS.DESCRIPTION'), false, 1, 1024),
            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, ['description'], fields));
    }

}
